import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Alert } from 'app/models/alert.model';
import { AlertsMapComponent } from '../alerts-map/alerts-map.component';
import { AlertService } from 'app/services/alert.service';


@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit, AfterViewInit {

  autoCenter: boolean = true;

  //Centre de la GoogleMap
  center: google.maps.LatLngLiteral;

  @ViewChild('mapControl') public mapControl: AlertsMapComponent;

  alerts: Alert[] = [];
  selectedAlert: Alert | null = null;
  
  constructor(
    private alertService: AlertService,
    private changeDetector: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadAlerts();

    this.center= {
      lat: -1.43,
      lng: -48.49
    };
  }

  async ngAfterViewInit(): Promise<void> {

  }

  loadAlerts(): void {
    this.alertService.getAlerts(200).subscribe(alerts => {
      this.alerts = alerts;
        this.changeDetector.detectChanges();

        this.mapControl.alertSelected.subscribe(
          alert => this.selectAlert(alert)
        );

        const lastAlert = this.alerts[this.alerts.length - 1];
        if (lastAlert) {
          this.center = {
            lat: Number.parseFloat(lastAlert.lat.toString()),
            lng: Number.parseFloat(lastAlert.lng.toString())
          };
        }
    });
  }

  getAlerts(): Alert[] {
    return this.alerts;
  }

  authCenterChanged(event: boolean): void {
    this.autoCenter = event;
  }

/**
   * Fonction pour sélectionner une alerte
   * Sur la map, puis dans le tableau
   * @param alert
   */
  async selectAlert(alert: Alert) { 
    //Déselection de tous les markers
    this.stopAllAnimations();

    console.log("Select alert:", alert);

    //Sélection
    this.selectedAlert = alert;

    //Centrage de la map sur les coordonnées de l'alerte
    if (this.autoCenter == true) {
      this.center = {
        lat: Number.parseFloat(alert.lat.toString()),
        lng: Number.parseFloat(alert.lng.toString())
      };

      this.mapControl.map.googleMap.setCenter(this.center);
    }
    
    //Sélection marker
    setTimeout(() => {
      alert.pin?.setAnimation(null);
      alert.pinLogo?.setAnimation(null);
      alert.pin?.setAnimation(google.maps.Animation.BOUNCE);
      alert.pinLogo?.setAnimation(google.maps.Animation.BOUNCE);
    }, 500);

    //CIRCLE ACCURACY
    if (alert.accuracy !== null && alert.accuracy !== undefined) {
      const circleCenter: google.maps.LatLngLiteral = {
        lat: alert.lat,
        lng: alert.lng
      }
      const circleOptions = {
        strokeColor: "#007BFF",
        strokeOpacity: 0.6,
        fillOpacity: 0.2,
        fillColor: "#007BFF"
      }
      alert.circle = new google.maps.Circle(circleOptions);
      alert.circle.setRadius(alert.accuracy);
      alert.circle.setMap(this.mapControl.map.googleMap);
      alert.circle.setCenter(circleCenter);
    }

    //ZOOM LEVEL
    if (this.autoCenter == true) {
      this.mapControl.map.googleMap?.setZoom(18);
    }
  }

  stopAllAnimations() {
    this.alerts.forEach((alert, index) => {
      alert.pin?.setAnimation(null);
      alert.pinLogo?.setAnimation(null);
      alert.circle?.setMap(null);
      alert.circle = null;
    });
  }


}
